(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1905],{

/***/ 89265:
/***/ (function(module) {

(function (global, factory) {
   true ? module.exports = factory() :
  0;
}(this, (function () { 'use strict';

  /**
  * Utility function to execute callback for eack key->value pair.
  */
  function forEach(obj, callback) {
    if (obj) {
      for (var key in obj) {
        // eslint-disable-line no-restricted-syntax
        if ({}.hasOwnProperty.call(obj, key)) {
          callback(key, obj[key]);
        }
      }
    }
  }
  /**
  * The function returns true if the string passed to it has no content.
  */

  function isEmptyString(str) {
    if (str === undefined || str === null || str.length === 0 || str.trim().length === 0) {
      return true;
    }

    return false;
  }

  /**
  * Mapping block-type to corresponding html tag.
  */

  var blockTypesMapping = {
    unstyled: 'p',
    'header-one': 'h1',
    'header-two': 'h2',
    'header-three': 'h3',
    'header-four': 'h4',
    'header-five': 'h5',
    'header-six': 'h6',
    'unordered-list-item': 'ul',
    'ordered-list-item': 'ol',
    blockquote: 'blockquote',
    code: 'pre'
  };
  /**
  * Function will return HTML tag for a block.
  */

  function getBlockTag(type) {
    return type && blockTypesMapping[type];
  }
  /**
  * Function will return style string for a block.
  */

  function getBlockStyle(data) {
    var styles = '';
    forEach(data, function (key, value) {
      if (value) {
        styles += "".concat(key, ":").concat(value, ";");
      }
    });
    return styles;
  }
  /**
  * The function returns an array of hashtag-sections in blocks.
  * These will be areas in block which have hashtags applicable to them.
  */

  function getHashtagRanges(blockText, hashtagConfig) {
    var sections = [];

    if (hashtagConfig) {
      var counter = 0;
      var startIndex = 0;
      var text = blockText;
      var trigger = hashtagConfig.trigger || '#';
      var separator = hashtagConfig.separator || ' ';

      for (; text.length > 0 && startIndex >= 0;) {
        if (text[0] === trigger) {
          startIndex = 0;
          counter = 0;
          text = text.substr(trigger.length);
        } else {
          startIndex = text.indexOf(separator + trigger);

          if (startIndex >= 0) {
            text = text.substr(startIndex + (separator + trigger).length);
            counter += startIndex + separator.length;
          }
        }

        if (startIndex >= 0) {
          var endIndex = text.indexOf(separator) >= 0 ? text.indexOf(separator) : text.length;
          var hashtag = text.substr(0, endIndex);

          if (hashtag && hashtag.length > 0) {
            sections.push({
              offset: counter,
              length: hashtag.length + trigger.length,
              type: 'HASHTAG'
            });
          }

          counter += trigger.length;
        }
      }
    }

    return sections;
  }
  /**
  * The function returns an array of entity-sections in blocks.
  * These will be areas in block which have same entity or no entity applicable to them.
  */


  function getSections(block, hashtagConfig) {
    var sections = [];
    var lastOffset = 0;
    var sectionRanges = block.entityRanges.map(function (range) {
      var offset = range.offset,
          length = range.length,
          key = range.key;
      return {
        offset: offset,
        length: length,
        key: key,
        type: 'ENTITY'
      };
    });
    sectionRanges = sectionRanges.concat(getHashtagRanges(block.text, hashtagConfig));
    sectionRanges = sectionRanges.sort(function (s1, s2) {
      return s1.offset - s2.offset;
    });
    sectionRanges.forEach(function (r) {
      if (r.offset > lastOffset) {
        sections.push({
          start: lastOffset,
          end: r.offset
        });
      }

      sections.push({
        start: r.offset,
        end: r.offset + r.length,
        entityKey: r.key,
        type: r.type
      });
      lastOffset = r.offset + r.length;
    });

    if (lastOffset < block.text.length) {
      sections.push({
        start: lastOffset,
        end: block.text.length
      });
    }

    return sections;
  }
  /**
  * Function to check if the block is an atomic entity block.
  */


  function isAtomicEntityBlock(block) {
    if (block.entityRanges.length > 0 && (isEmptyString(block.text) || block.type === 'atomic')) {
      return true;
    }

    return false;
  }
  /**
  * The function will return array of inline styles applicable to the block.
  */


  function getStyleArrayForBlock(block) {
    var text = block.text,
        inlineStyleRanges = block.inlineStyleRanges;
    var inlineStyles = {
      BOLD: new Array(text.length),
      ITALIC: new Array(text.length),
      UNDERLINE: new Array(text.length),
      STRIKETHROUGH: new Array(text.length),
      CODE: new Array(text.length),
      SUPERSCRIPT: new Array(text.length),
      SUBSCRIPT: new Array(text.length),
      COLOR: new Array(text.length),
      BGCOLOR: new Array(text.length),
      FONTSIZE: new Array(text.length),
      FONTFAMILY: new Array(text.length),
      length: text.length
    };

    if (inlineStyleRanges && inlineStyleRanges.length > 0) {
      inlineStyleRanges.forEach(function (range) {
        var offset = range.offset;
        var length = offset + range.length;

        for (var i = offset; i < length; i += 1) {
          if (range.style.indexOf('color-') === 0) {
            inlineStyles.COLOR[i] = range.style.substring(6);
          } else if (range.style.indexOf('bgcolor-') === 0) {
            inlineStyles.BGCOLOR[i] = range.style.substring(8);
          } else if (range.style.indexOf('fontsize-') === 0) {
            inlineStyles.FONTSIZE[i] = range.style.substring(9);
          } else if (range.style.indexOf('fontfamily-') === 0) {
            inlineStyles.FONTFAMILY[i] = range.style.substring(11);
          } else if (inlineStyles[range.style]) {
            inlineStyles[range.style][i] = true;
          }
        }
      });
    }

    return inlineStyles;
  }
  /**
  * The function will return inline style applicable at some offset within a block.
  */


  function getStylesAtOffset(inlineStyles, offset) {
    var styles = {};

    if (inlineStyles.COLOR[offset]) {
      styles.COLOR = inlineStyles.COLOR[offset];
    }

    if (inlineStyles.BGCOLOR[offset]) {
      styles.BGCOLOR = inlineStyles.BGCOLOR[offset];
    }

    if (inlineStyles.FONTSIZE[offset]) {
      styles.FONTSIZE = inlineStyles.FONTSIZE[offset];
    }

    if (inlineStyles.FONTFAMILY[offset]) {
      styles.FONTFAMILY = inlineStyles.FONTFAMILY[offset];
    }

    if (inlineStyles.UNDERLINE[offset]) {
      styles.UNDERLINE = true;
    }

    if (inlineStyles.ITALIC[offset]) {
      styles.ITALIC = true;
    }

    if (inlineStyles.BOLD[offset]) {
      styles.BOLD = true;
    }

    if (inlineStyles.STRIKETHROUGH[offset]) {
      styles.STRIKETHROUGH = true;
    }

    if (inlineStyles.CODE[offset]) {
      styles.CODE = true;
    }

    if (inlineStyles.SUBSCRIPT[offset]) {
      styles.SUBSCRIPT = true;
    }

    if (inlineStyles.SUPERSCRIPT[offset]) {
      styles.SUPERSCRIPT = true;
    }

    return styles;
  }
  /**
  * Function returns true for a set of styles if the value of these styles at an offset
  * are same as that on the previous offset.
  */

  function sameStyleAsPrevious(inlineStyles, styles, index) {
    var sameStyled = true;

    if (index > 0 && index < inlineStyles.length) {
      styles.forEach(function (style) {
        sameStyled = sameStyled && inlineStyles[style][index] === inlineStyles[style][index - 1];
      });
    } else {
      sameStyled = false;
    }

    return sameStyled;
  }
  /**
  * Function returns html for text depending on inline style tags applicable to it.
  */

  function addInlineStyleMarkup(style, content) {
    if (style === 'BOLD') {
      return "<strong>".concat(content, "</strong>");
    }

    if (style === 'ITALIC') {
      return "<em>".concat(content, "</em>");
    }

    if (style === 'UNDERLINE') {
      return "<ins>".concat(content, "</ins>");
    }

    if (style === 'STRIKETHROUGH') {
      return "<del>".concat(content, "</del>");
    }

    if (style === 'CODE') {
      return "<code>".concat(content, "</code>");
    }

    if (style === 'SUPERSCRIPT') {
      return "<sup>".concat(content, "</sup>");
    }

    if (style === 'SUBSCRIPT') {
      return "<sub>".concat(content, "</sub>");
    }

    return content;
  }
  /**
  * The function returns text for given section of block after doing required character replacements.
  */

  function getSectionText(text) {
    if (text && text.length > 0) {
      var chars = text.map(function (ch) {
        switch (ch) {
          case '\n':
            return '<br>';

          case '&':
            return '&amp;';

          case '<':
            return '&lt;';

          case '>':
            return '&gt;';

          default:
            return ch;
        }
      });
      return chars.join('');
    }

    return '';
  }
  /**
  * Function returns html for text depending on inline style tags applicable to it.
  */


  function addStylePropertyMarkup(styles, text) {
    if (styles && (styles.COLOR || styles.BGCOLOR || styles.FONTSIZE || styles.FONTFAMILY)) {
      var styleString = 'style="';

      if (styles.COLOR) {
        styleString += "color: ".concat(styles.COLOR, ";");
      }

      if (styles.BGCOLOR) {
        styleString += "background-color: ".concat(styles.BGCOLOR, ";");
      }

      if (styles.FONTSIZE) {
        styleString += "font-size: ".concat(styles.FONTSIZE).concat(/^\d+$/.test(styles.FONTSIZE) ? 'px' : '', ";");
      }

      if (styles.FONTFAMILY) {
        styleString += "font-family: ".concat(styles.FONTFAMILY, ";");
      }

      styleString += '"';
      return "<span ".concat(styleString, ">").concat(text, "</span>");
    }

    return text;
  }
  /**
  * Function will return markup for Entity.
  */

  function getEntityMarkup(entityMap, entityKey, text, customEntityTransform) {
    var entity = entityMap[entityKey];

    if (typeof customEntityTransform === 'function') {
      var html = customEntityTransform(entity, text);

      if (html) {
        return html;
      }
    }

    if (entity.type === 'MENTION') {
      return "<a href=\"".concat(entity.data.url, "\" class=\"wysiwyg-mention\" data-mention data-value=\"").concat(entity.data.value, "\">").concat(text, "</a>");
    }

    if (entity.type === 'LINK') {
      var targetOption = entity.data.targetOption || '_self';
      return "<a href=\"".concat(entity.data.url, "\" target=\"").concat(targetOption, "\">").concat(text, "</a>");
    }

    if (entity.type === 'IMAGE') {
      var alignment = entity.data.alignment;

      if (alignment && alignment.length) {
        return "<div style=\"text-align:".concat(alignment, ";\"><img src=\"").concat(entity.data.src, "\" alt=\"").concat(entity.data.alt, "\" style=\"height: ").concat(entity.data.height, ";width: ").concat(entity.data.width, "\"/></div>");
      }

      return "<img src=\"".concat(entity.data.src, "\" alt=\"").concat(entity.data.alt, "\" style=\"height: ").concat(entity.data.height, ";width: ").concat(entity.data.width, "\"/>");
    }

    if (entity.type === 'EMBEDDED_LINK') {
      return "<iframe width=\"".concat(entity.data.width, "\" height=\"").concat(entity.data.height, "\" src=\"").concat(entity.data.src, "\" frameBorder=\"0\"></iframe>");
    }

    return text;
  }
  /**
  * For a given section in a block the function will return a further list of sections,
  * with similar inline styles applicable to them.
  */


  function getInlineStyleSections(block, styles, start, end) {
    var styleSections = [];
    var text = Array.from(block.text);

    if (text.length > 0) {
      var inlineStyles = getStyleArrayForBlock(block);
      var section;

      for (var i = start; i < end; i += 1) {
        if (i !== start && sameStyleAsPrevious(inlineStyles, styles, i)) {
          section.text.push(text[i]);
          section.end = i + 1;
        } else {
          section = {
            styles: getStylesAtOffset(inlineStyles, i),
            text: [text[i]],
            start: i,
            end: i + 1
          };
          styleSections.push(section);
        }
      }
    }

    return styleSections;
  }
  /**
  * Replace leading blank spaces by &nbsp;
  */


  function trimLeadingZeros(sectionText) {
    if (sectionText) {
      var replacedText = sectionText;

      for (var i = 0; i < replacedText.length; i += 1) {
        if (sectionText[i] === ' ') {
          replacedText = replacedText.replace(' ', '&nbsp;');
        } else {
          break;
        }
      }

      return replacedText;
    }

    return sectionText;
  }
  /**
  * Replace trailing blank spaces by &nbsp;
  */

  function trimTrailingZeros(sectionText) {
    if (sectionText) {
      var replacedText = sectionText;

      for (var i = replacedText.length - 1; i >= 0; i -= 1) {
        if (replacedText[i] === ' ') {
          replacedText = "".concat(replacedText.substring(0, i), "&nbsp;").concat(replacedText.substring(i + 1));
        } else {
          break;
        }
      }

      return replacedText;
    }

    return sectionText;
  }
  /**
  * The method returns markup for section to which inline styles
  * like BOLD, ITALIC, UNDERLINE, STRIKETHROUGH, CODE, SUPERSCRIPT, SUBSCRIPT are applicable.
  */

  function getStyleTagSectionMarkup(styleSection) {
    var styles = styleSection.styles,
        text = styleSection.text;
    var content = getSectionText(text);
    forEach(styles, function (style, value) {
      content = addInlineStyleMarkup(style, content);
    });
    return content;
  }
  /**
  * The method returns markup for section to which inline styles
  like color, background-color, font-size are applicable.
  */


  function getInlineStyleSectionMarkup(block, styleSection) {
    var styleTagSections = getInlineStyleSections(block, ['BOLD', 'ITALIC', 'UNDERLINE', 'STRIKETHROUGH', 'CODE', 'SUPERSCRIPT', 'SUBSCRIPT'], styleSection.start, styleSection.end);
    var styleSectionText = '';
    styleTagSections.forEach(function (stylePropertySection) {
      styleSectionText += getStyleTagSectionMarkup(stylePropertySection);
    });
    styleSectionText = addStylePropertyMarkup(styleSection.styles, styleSectionText);
    return styleSectionText;
  }
  /*
  * The method returns markup for an entity section.
  * An entity section is a continuous section in a block
  * to which same entity or no entity is applicable.
  */


  function getSectionMarkup(block, entityMap, section, customEntityTransform) {
    var entityInlineMarkup = [];
    var inlineStyleSections = getInlineStyleSections(block, ['COLOR', 'BGCOLOR', 'FONTSIZE', 'FONTFAMILY'], section.start, section.end);
    inlineStyleSections.forEach(function (styleSection) {
      entityInlineMarkup.push(getInlineStyleSectionMarkup(block, styleSection));
    });
    var sectionText = entityInlineMarkup.join('');

    if (section.type === 'ENTITY') {
      if (section.entityKey !== undefined && section.entityKey !== null) {
        sectionText = getEntityMarkup(entityMap, section.entityKey, sectionText, customEntityTransform); // eslint-disable-line max-len
      }
    } else if (section.type === 'HASHTAG') {
      sectionText = "<a href=\"".concat(sectionText, "\" class=\"wysiwyg-hashtag\">").concat(sectionText, "</a>");
    }

    return sectionText;
  }
  /**
  * Function will return the markup for block preserving the inline styles and
  * special characters like newlines or blank spaces.
  */


  function getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform) {
    var blockMarkup = [];
    var sections = getSections(block, hashtagConfig);
    sections.forEach(function (section, index) {
      var sectionText = getSectionMarkup(block, entityMap, section, customEntityTransform);

      if (index === 0) {
        sectionText = trimLeadingZeros(sectionText);
      }

      if (index === sections.length - 1) {
        sectionText = trimTrailingZeros(sectionText);
      }

      blockMarkup.push(sectionText);
    });
    return blockMarkup.join('');
  }
  /**
  * Function will return html for the block.
  */

  function getBlockMarkup(block, entityMap, hashtagConfig, directional, customEntityTransform) {
    var blockHtml = [];

    if (isAtomicEntityBlock(block)) {
      blockHtml.push(getEntityMarkup(entityMap, block.entityRanges[0].key, undefined, customEntityTransform));
    } else {
      var blockTag = getBlockTag(block.type);

      if (blockTag) {
        blockHtml.push("<".concat(blockTag));
        var blockStyle = getBlockStyle(block.data);

        if (blockStyle) {
          blockHtml.push(" style=\"".concat(blockStyle, "\""));
        }

        if (directional) {
          blockHtml.push(' dir = "auto"');
        }

        blockHtml.push('>');
        blockHtml.push(getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform));
        blockHtml.push("</".concat(blockTag, ">"));
      }
    }

    blockHtml.push('\n');
    return blockHtml.join('');
  }

  /**
  * Function to check if a block is of type list.
  */

  function isList(blockType) {
    return blockType === 'unordered-list-item' || blockType === 'ordered-list-item';
  }
  /**
  * Function will return html markup for a list block.
  */

  function getListMarkup(listBlocks, entityMap, hashtagConfig, directional, customEntityTransform) {
    var listHtml = [];
    var nestedListBlock = [];
    var previousBlock;
    listBlocks.forEach(function (block) {
      var nestedBlock = false;

      if (!previousBlock) {
        listHtml.push("<".concat(getBlockTag(block.type), ">\n"));
      } else if (previousBlock.type !== block.type) {
        listHtml.push("</".concat(getBlockTag(previousBlock.type), ">\n"));
        listHtml.push("<".concat(getBlockTag(block.type), ">\n"));
      } else if (previousBlock.depth === block.depth) {
        if (nestedListBlock && nestedListBlock.length > 0) {
          listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
          nestedListBlock = [];
        }
      } else {
        nestedBlock = true;
        nestedListBlock.push(block);
      }

      if (!nestedBlock) {
        listHtml.push('<li');
        var blockStyle = getBlockStyle(block.data);

        if (blockStyle) {
          listHtml.push(" style=\"".concat(blockStyle, "\""));
        }

        if (directional) {
          listHtml.push(' dir = "auto"');
        }

        listHtml.push('>');
        listHtml.push(getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform));
        listHtml.push('</li>\n');
        previousBlock = block;
      }
    });

    if (nestedListBlock && nestedListBlock.length > 0) {
      listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
    }

    listHtml.push("</".concat(getBlockTag(previousBlock.type), ">\n"));
    return listHtml.join('');
  }

  /**
  * The function will generate html markup for given draftjs editorContent.
  */

  function draftToHtml(editorContent, hashtagConfig, directional, customEntityTransform) {
    var html = [];

    if (editorContent) {
      var blocks = editorContent.blocks,
          entityMap = editorContent.entityMap;

      if (blocks && blocks.length > 0) {
        var listBlocks = [];
        blocks.forEach(function (block) {
          if (isList(block.type)) {
            listBlocks.push(block);
          } else {
            if (listBlocks.length > 0) {
              var listHtml = getListMarkup(listBlocks, entityMap, hashtagConfig, customEntityTransform); // eslint-disable-line max-len

              html.push(listHtml);
              listBlocks = [];
            }

            var blockHtml = getBlockMarkup(block, entityMap, hashtagConfig, directional, customEntityTransform);
            html.push(blockHtml);
          }
        });

        if (listBlocks.length > 0) {
          var listHtml = getListMarkup(listBlocks, entityMap, hashtagConfig, directional, customEntityTransform); // eslint-disable-line max-len

          html.push(listHtml);
          listBlocks = [];
        }
      }
    }

    return html.join('');
  }

  return draftToHtml;

})));


/***/ }),

/***/ 41905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ RichTextBlogComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/draftjs-to-html/lib/draftjs-to-html.js
var draftjs_to_html = __webpack_require__(89265);
var draftjs_to_html_default = /*#__PURE__*/__webpack_require__.n(draftjs_to_html);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/blog/layouts/rich-text-blog/rich-text-blog-component.scss.js


var StyledRichTextBlogComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ez0z8ko0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;display:flex;justify-content:center;.rich-text-body{font-size:0.875rem;}&.left{justify-content:flex-start;}&.right{justify-content:flex-end;}");

;// CONCATENATED MODULE: ./segments/desktop/blog/layouts/rich-text-blog/rich-text-blog-component.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






var DEFAULT_WIDTH_PRECENTAGE = 70;
var DEFAULT_PROPS_BODY_CONTENT = {
    entityMap: {},
    blocks: [
        {
            key: "637gr",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
            type: "unstyled",
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        }
    ]
};
var RichTextBlogComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(RichTextBlogComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(RichTextBlogComponent);
    function RichTextBlogComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, RichTextBlogComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "convertBodyFromWswygJSONToHTML", function(body) {
            return draftjs_to_html_default()(body);
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(RichTextBlogComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, body = _props.body, width = _props.width, isMobileOrTabletBrowser = _props.isMobileOrTabletBrowser, align = _props.align;
                var finalWidth = isMobileOrTabletBrowser ? 100 : width;
                var widthInPercentage = "".concat(finalWidth, "%");
                var htmlBody = this.convertBodyFromWswygJSONToHTML(body);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRichTextBlogComponent, {
                    className: classnames_default()("rich-text-blog-component", align),
                    style: {
                        width: widthInPercentage
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "rich-text-body",
                        dangerouslySetInnerHTML: {
                            __html: htmlBody
                        }
                    })
                });
            }
        }
    ]);
    return RichTextBlogComponent;
}(react.PureComponent);

RichTextBlogComponent.defaultProps = {
    width: DEFAULT_WIDTH_PRECENTAGE,
    body: DEFAULT_PROPS_BODY_CONTENT,
    align: align_types.ALIGN_TYPES.CENTER
};


/***/ })

}]);